import React from "react";
import styles from "./TechSupport.module.css";

const SUPPORT_PHONE = "(805) 452-5170";
const SUPPORT_EMAIL = "help@agtechlogic.com";

const TechSupport = () => {
  return (
    <>
      <div className={styles.container}>
        <p className="text-2xl font-medium tracking-tight text-[#031832] sm:text-4xl pb-5 text-center">
          Tech Support
        </p>

        <p className="text-xl font-medium tracking-tight text-[#031832] text-center pb-4">
          Phone:{" "}
          <a href="tel:+15551234567" className="underline">
            {SUPPORT_PHONE}
          </a>
        </p>

        <p className="text-xl font-medium tracking-tight text-[#031832] text-center pb-10">
          Email:{" "}
          <a
            href={`mailto:${SUPPORT_EMAIL}`}
            className="underline"
          >
            {SUPPORT_EMAIL}
          </a>
        </p>
      </div>
    </>
  );
};

export default TechSupport;
